'use client';

import { useSearchParams } from 'next/navigation';
import { useRouter } from 'next/router';
import { useEffect } from 'react';

export const YM_ID = 38452385;
export const VK_ID = 3785277;
export const TOP100_ID = 7748435;

const Metrics = () => {
    const { pathname } = useRouter();
    const searchParams = useSearchParams();

    useEffect(() => {
        (window as any).ym?.(YM_ID, 'hit', window.location.href);
        (window as any)._tmr?.push({ id: `${VK_ID}`, type: 'pageView', start: new Date().getTime() });
        window._txq?.push(['track', 'PageView']);
    }, [pathname, searchParams]);

    return (
        <>
            <div
                dangerouslySetInnerHTML={{
                    __html: `
                    <!-- Yandex.Metrika counter -->
                    <script type="text/javascript"> 
                        (function(m,e,t,r,i,k,a){m[i]=m[i]||function(){(m[i].a=m[i].a||[]).push(arguments)}; m[i].l=1*new Date(); for (var j = 0; j < document.scripts.length; j++) {if (document.scripts[j].src === r) { return; }} k=e.createElement(t),a=e.getElementsByTagName(t)[0],k.async=1,k.src=r,a.parentNode.insertBefore(k,a)}) (window, document, "script", "https://mc.yandex.ru/metrika/tag.js", "ym");
                        
                        ym(${YM_ID}, "init", { defer:true, clickmap:true, trackLinks:true, accurateTrackBounce:true, webvisor:true });
                    </script>
                    <noscript><div><img src="https://mc.yandex.ru/watch/${YM_ID}" style="position:absolute; left:-9999px;" alt="" /></div></noscript>
                    <!-- /Yandex.Metrika counter -->

                    <!-- Top.Mail.Ru counter -->
                        <script type="text/javascript">
                        var _tmr = window._tmr || (window._tmr = []);
                        _tmr.push({id: "${VK_ID}", type: "pageView", start: (new Date()).getTime()});
                        (function (d, w, id) {
                        if (d.getElementById(id)) return;
                        var ts = d.createElement("script"); ts.type = "text/javascript"; ts.async = true; ts.id = id;
                        ts.src = "https://top-fwz1.mail.ru/js/code.js";
                        var f = function () {var s = d.getElementsByTagName("script")[0]; s.parentNode.insertBefore(ts, s);};
                        if (w.opera == "[object Opera]") { d.addEventListener("DOMContentLoaded", f, false); } else { f(); }
                        })(document, window, "tmr-code");
                    </script>
                    <noscript><div><img src="https://top-fwz1.mail.ru/counter?id=${VK_ID};js=na" style="position:absolute;left:-9999px;" alt="Top.Mail.Ru" /></div></noscript>
                    
                    <!-- /Top.Mail.Ru counter -->

                    <script src="//cdn.callibri.ru/callibri.js" type="text/javascript" charset="utf-8" defer></script>

                    <!-- Top100 (Kraken) Counter -->
                    <script>
                        (function (w, d, c) {
                        (w[c] = w[c] || []).push(function() {
                            var options = {
                                project: ${TOP100_ID},
                            };
                            try {
                                w.top100Counter = new top100(options);
                            } catch(e) { }
                        });
                        var n = d.getElementsByTagName("script")[0],
                        s = d.createElement("script"),
                        f = function () { n.parentNode.insertBefore(s, n); };
                        s.type = "text/javascript";
                        s.async = true;
                        s.src =
                        (d.location.protocol == "https:" ? "https:" : "http:") +
                        "//st.top100.ru/top100/top100.js";

                        if (w.opera == "[object Opera]") {
                        d.addEventListener("DOMContentLoaded", f, false);
                    } else { f(); }
                    })(window, document, "_top100q");
                    </script>
                    <noscript>
                    <img src="//counter.rambler.ru/top100.cnt?pid=${TOP100_ID}" alt="Топ-100" />
                    </noscript>
                    <!-- END Top100 (Kraken) Counter -->
                    `,
                }}
            ></div>
        </>
    );
};

export default Metrics;
